import React, { useState } from 'react';
import { Flex, Text, Box, Image } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import GroupItem from '../components/GroupItem';
import { useAuthContext } from '../AuthProvider';
import { useActivity } from '../hooks/useActivity';
import ScheduleItem from '../components/ScheduleItem';
import { margin } from '../utils/timestamp';
import NoHistory from '../assets/Icon/illust/NoHistory.svg';
import HomeHeader from '../components/HomeHeader';

const Activity = () => {
  const { user } = useAuthContext();
  const { groups, schedulesByDate } = useActivity(user?.uid || '');
  const [currentDateIdx, setCurrentDateIdx] = useState(0);

  return (
    <Flex pos="relative" h="100%" flexDirection="column" align="center" pb={8}>
      <Flex px="1rem" width="100%" flexDirection="column">
        <HomeHeader title="내 활동" />
      </Flex>
      <Flex flexDir="column" w="100%" py="20px" px="26px">
        <Text fontWeight="bold" color="#383838">
          내 모임
        </Text>
        {groups.length === 0 && (
          <Flex py="28px" width="100%" justify="center">
            <Image src={NoHistory} />
            <Flex
              ml="13px"
              my="9px"
              flexDir="column"
              alignItems="start"
              justify="center"
            >
              <Text fontSize="14px" fontWeight="semibold" color="#9E9E9E">
                가입중인 모임이 없어요.
              </Text>
              <Text fontSize="10px" fontWeight="semibold" color="#C6C6C6">
                보드게임 모임을 찾아 다양한 보드게임을 즐겨보세요!
              </Text>
            </Flex>
          </Flex>
        )}
        {groups.map((group) => (
          <Link
            key={group.id}
            to={`/group/${group.id}`}
            style={{ width: '100%' }}
          >
            <GroupItem group={group} />
          </Link>
        ))}
      </Flex>
      <Box height="8px" bgColor="#EFF2F5" width="100%" />
      <Flex flexDir="column" w="100%" py="20px" px="26px">
        <Text fontWeight="bold" color="#383838">
          참여 일정
        </Text>
        <Flex justifyContent="space-between" width="100%">
          {schedulesByDate.map(({ format, schedules }, idx) => (
            <Flex
              key={format}
              onClick={() => setCurrentDateIdx(idx)}
              flexDir="column"
              color={currentDateIdx === idx ? '#383838' : '#9E9E9E'}
              alignItems="center"
              borderRadius="6px"
              bgColor={currentDateIdx === idx ? '#FFEFF0' : 'none'}
              py="7px"
              px="10px"
            >
              <Text fontWeight="light" fontSize="12px">
                {format.slice(-2, -1)}
              </Text>
              <Flex alignItems="center" position="relative">
                <Text fontWeight="bold" fontSize="18px">
                  {margin(format.split('.').pop()?.split(' ').shift() ?? '', 2)}
                </Text>
                {schedules.length > 0 && (
                  <Box
                    position="absolute"
                    width="4px"
                    height="4px"
                    bgColor="#E4756E"
                    borderRadius="50%"
                    right="-5px"
                    top="4px"
                  />
                )}
              </Flex>
            </Flex>
          ))}
        </Flex>
        {schedulesByDate[currentDateIdx].schedules.length === 0 && (
          <Flex py="28px" width="100%" justify="center">
            <Image src={NoHistory} />
            <Flex
              ml="13px"
              my="9px"
              flexDir="column"
              alignItems="start"
              justify="center"
            >
              <Text fontSize="14px" fontWeight="semibold" color="#9E9E9E">
                참여한 일정이 없어요.
              </Text>
              <Text fontSize="10px" fontWeight="semibold" color="#C6C6C6">
                보드게임 모임을 찾아 다양한 보드게임을 즐겨보세요!
              </Text>
            </Flex>
          </Flex>
        )}
        {schedulesByDate[currentDateIdx].schedules.map((schedule) => (
          <Link
            key={schedule.id}
            to={`/group/${schedule.groupId}/schedule/${schedule.id}`}
            style={{ width: '100%' }}
          >
            <ScheduleItem schedule={schedule} />
          </Link>
        ))}
      </Flex>
    </Flex>
  );
};

export default Activity;
